let app
//2025-08-29 - inutile
//modifica date da-a
//const { subtractMonthsToDate } = require('@/api/base_entity')
//modifica date da-a
//2025-08-29 - inutile
module.exports = {
    setApp: (appp) => {
        app = appp
    },
    "title": "Email",
    "entityName": "email",
    "pagination": {
        //issue troppe emails aggiunto itemsPerPageOptions , se not undefined lo prende !
        "itemsPerPageOptions" : [5, 10, 25,100],
        //issue troppe emails aggiunto itemsPerPageOptions , se not undefined lo prende !
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    // "select": ["id", "account", "to", "cc", "bcc", "insert_at", "sent_at", "subject", "status"],
    "fields": [
        {
            "value": "account_id",
            "text": "Account",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            render: (item) => {
                return item.account.first_name + ' ' + (item.account.last_name || '')
            },
            filter: (item, search) => {
                //issue 189
                if (search) return { urs : [{ 'account.first_name': `%${search}%`}, { 'account.last_name': `%${search}%`}]}
                //issue 189
            },

        },
        {
            "value": "to",
            "text": "Recipients",
            "type": "text",
            "table": {
                "filter": true
            },
            render: (item) => {
                let aCount = 0
                let bCount = 0
                let cCount = 0
                if(item.to) {
                    aCount = item.to.length
                }
                if(item.cc) {
                    bCount = item.cc.length
                }
                if(item.bcc) {
                    cCount = item.bcc.length
                }
                return `To:${aCount}  Cc:${bCount}  Bcc:${cCount}`
            },
            filter: (item, search) => {
                if (search) return [{ 'to': `%${search}%`}, { 'cc': `%${search}%`}, { 'bcc': `%${search}%`}]
            },
            tooltip: (item) => {
                let a = (item.to || '') + "\n" + (item.cc || '') + "\n" + (item.bcc || '')
                return a.replaceAll(',', "\n")
            }

        },
        {
            "value": "subject",
            "text": "Subject",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            filter: (item, search) => {
                if (search) return { 'subject': `%${search}%`}
            },
        },
        {
            "value": "status",
            "text": "Status",
            "type": "list",
            render: (item) => {

                if (item.status == 'sent') {
                    return "<font style='color:green'><b>SENT</b></font><br>" //Issue 189 //+ item.sent_at
                }

                if (item.status == 'queued') {
                    return "<font style='color:orange'><b>QUEUED</b></font><br>" //Issue 189 //+ item.insert_at
                }

                if (item.status == 'error') {
                    return "<font style='color:red'><b>ERROR</b></font><br>" //Issue 189 //+ item.insert_at
                }

            },
            tooltip: (item) => {
                return item.status == 'error' ? item.error : null
            },
            click: (item) => {
                navigator.clipboard.writeText(item.error)
                app.clicked(item)
            },
            "table": {
                "sortable": true,
                "filter": true
            },
            list: ['queued', 'sent', 'error']
        },
        //Issue 189
        {
            value: 'insert_at',
            text: 'Insert at',
            //issue 189
            filtertofrom: true,
            //issue 189
            //2025-08-29 - inutile
            //modifica date da-a
            //filtertofromini: subtractMonthsToDate(new Date(), 1),
            //filtertofromend: new Date(),
            //modifica date da-a
            //2025-08-29 - inutile
            'type': 'date',
            'table': {
              'sortable': true,
              'filter': true
            },
            tooltip: () => {
              return "Click to copy the REQUEST and RESPONSE json into the clipboard"
            },
            click: (item) => {
              const value = {
                REQUEST: item.request,
                RESPONSE: item.response
              }
              navigator.clipboard.writeText(JSON.stringify(value, null, 2))
              app.clicked(item)
            }
          }
          //Issue 189
    ],
    "actions": [
        { "value": "read", "text": "View", "icon": "mdi-eye", "color": "primary" }
    ]
}